import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Media, MediaBody, MediaLeft } from "@ht/components";
import MessageOptions from "./MessageOptions";
import getInitials from "../../../utils/getInitials";
import { activeChatAgentRoom } from "../../../app/chatAgent/chatAgentSlice";
import { IActiveRoom } from "../../../app/chatAgent/types";

interface IProps {
    name: string;
    status: string;
}

const MessageHeader: FC<IProps> = ({ name, status }) => {
    const { layoutType } = useAppSelector((state) => state.chatagent);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const backButtonHandler = () => {
        localStorage.removeItem('activeChatRoom');
        if (layoutType == "PAGE") navigate("/chat");
        dispatch(activeChatAgentRoom({} as IActiveRoom));
    };

    return (
        <div className="message-header bg-white px-5 py-3 h-[60px] flex items-center border-b border-gray-100">
            <button
                type="button"
                className="mr-3.8 text-3xl text-primary lg:hidden"
                onClick={backButtonHandler}
            >
                <i className="fa fa-angle-left"></i>
            </button>
            <Media className="items-center">
                <MediaLeft className="w-9 min-w-9">
                    <div className="bg-gray-200 rounded-full w-9 h-9 flex items-center justify-center text-base font-medium">
                        <span>
                            {getInitials(name)}
                        </span>
                    </div>
                </MediaLeft>
                <MediaBody className="ml-3.8 xxsToXs:max-w-[120px] xsToSm:max-w-[250px] sm:max-w-[450px] md:max-w-[650px] lg:max-w-[700px]">
                    <div className="text-md text-gray-700 font-semibold truncate" title={name}>{name}</div>
                    <div>{status}</div>
                </MediaBody>
            </Media>
            <MessageOptions />

        </div>
    );
};

export default MessageHeader;
